<template>
  <v-bottom-navigation
    :value="active"
    app
    fixed
    grow
    height="64"
    class="scan-bottom-nav"
    @change="onNavChange"
  >
    <v-btn value="menu" class="scan-bottom-nav__btn" :aria-label="$t('menu')">
      <div class="scan-bottom-nav__item">
        <span class="scan-bottom-nav__icon-wrap">
          <v-icon size="20">fal fa-utensils</v-icon>
        </span>
        <span class="scan-bottom-nav__label">{{ $t("menu") }}</span>
      </div>
    </v-btn>

    <v-btn value="cart" class="scan-bottom-nav__btn" :aria-label="$t('cart')">
      <div class="scan-bottom-nav__item">
        <span class="scan-bottom-nav__icon-wrap">
          <v-badge
            v-if="cartCount > 0"
            color="primary"
            :content="String(cartCount)"
            overlap
            offset-x="10"
            offset-y="10"
          >
            <v-icon size="20">fal fa-shopping-cart</v-icon>
          </v-badge>
          <v-icon v-else size="20">fal fa-shopping-cart</v-icon>
        </span>
        <span class="scan-bottom-nav__label">{{ $t("cart") }}</span>
      </div>
    </v-btn>

    <v-btn value="order" class="scan-bottom-nav__btn" :aria-label="$t('my_order')">
      <div class="scan-bottom-nav__item">
        <span class="scan-bottom-nav__icon-wrap">
          <v-icon size="20">fal fa-receipt</v-icon>
        </span>
        <span class="scan-bottom-nav__label">{{ $t("my_order") }}</span>
      </div>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import { mapState } from "pinia";
import { mainStore } from "@/stores/modules/cart";

export default {
  name: "ScanBottomNav",
  computed: {
    ...mapState(mainStore, ["cart"]),
    cartCount() {
      return (this.cart || []).length;
    },
    active() {
      const n = this.$route && this.$route.name;
      if (n === "cart") return "cart";
      if (n === "receipt") return "order";
      return "menu";
    },
  },
  methods: {
    onNavChange(val) {
      if (val === "menu") this.goMenu();
      else if (val === "cart") this.goCart();
      else if (val === "order") this.goOrder();
    },
    goMenu() {
      const s = localStorage.getItem("store_id");
      const b = localStorage.getItem("branch_id");
      const t = localStorage.getItem("table_id");
      const target = s && b && t ? `/scan/${s}/${b}/${t}` : "/";
      if (this.$route.path !== target) {
        this.$router.push(target);
      }
    },
    goCart() {
      if (this.$route.name !== "cart") {
        this.$router.push("/cart");
      }
    },
    goOrder() {
      if (this.$route.name !== "receipt") {
        this.$router.push("/receipt");
      }
    },
  },
};
</script>

<style scoped>
.scan-bottom-nav {
  background: rgba(255, 255, 255, 0.96) !important;
  -webkit-backdrop-filter: blur(16px);
  backdrop-filter: blur(16px);
  border-top: 0.5px solid var(--qr-card-border, rgba(40, 28, 16, 0.06)) !important;
  box-shadow: 0 -8px 24px rgba(40, 28, 16, 0.08);
  padding-bottom: env(safe-area-inset-bottom, 0px);
  z-index: 6;
  touch-action: manipulation;
}

.scan-bottom-nav ::v-deep .v-badge__badge {
  background-color: var(--qr-accent, #5b39c9) !important;
  border-color: var(--qr-accent, #5b39c9) !important;
}

.scan-bottom-nav__btn {
  min-height: 44px !important;
  height: auto !important;
  flex: 1 1 0;
}

.scan-bottom-nav__btn ::v-deep .v-btn__content {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  padding-top: 6px;
  padding-bottom: 8px;
}

.scan-bottom-nav__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 100%;
  max-width: 100%;
  min-height: 0;
}

.scan-bottom-nav__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
}

.scan-bottom-nav__label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--qr-muted, rgba(31, 24, 18, 0.55));
}

/* Active tab: match QR accent (Font Awesome icons may not follow Vuetify color prop) */
.scan-bottom-nav ::v-deep .v-btn--active {
  color: var(--qr-accent, #5b39c9) !important;
}

.scan-bottom-nav ::v-deep .v-btn--active .scan-bottom-nav__label {
  color: var(--qr-accent, #5b39c9) !important;
}

.scan-bottom-nav ::v-deep .v-btn--active .v-icon {
  color: var(--qr-accent, #5b39c9) !important;
}

@media (prefers-reduced-motion: reduce) {
  .scan-bottom-nav,
  .scan-bottom-nav__btn {
    transition: none !important;
  }
}
</style>
